/**
 * 特集付替設定取得リクエストVO
 *
 */
export class KYMW1319InputVO {
  /** 受注コード */
  public orderCode = '';
  /** 束ね企画開始受注コード */
  public startOrderCode = '';
  /** 束ね企画終了受注コード */
  public endOrderCode = '';
  /** 媒体区分 */
  public mediumType = '';
  /** 媒体名 */
  public mediumName = '';
  /** Ｐコード */
  public pcode = '';
  /** 商品案内用商品名 */
  public guideGoodsName = '';
  /** 工程管理No */
  public progressWorkNum = '';
  /** 編集ロックフラグ 0：閲覧モード、1：編集モード */
  public editLockFlag = '';
  /** 束ねフラグ 0：束ね企画対象外、1：束ね企画対象 */
  public bundleCatalogFlag = '';
  /** 束ね企画名 */
  public bundleCatalogRoundName = '';
}
